Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewSnapshotParser
  parse: (reviewSnapshotJson) ->
    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReviewSnapshotBuilder()
    builder.setText(reviewSnapshotJson.text)
    builder.setReviewId(reviewSnapshotJson.review_id)
    builder.setStarRating(reviewSnapshotJson.star_rating)
    authorParser = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAuthorParser
    builder.setAuthor(authorParser.parse(reviewSnapshotJson.author))
    builder.setCreatedAt(new Date(reviewSnapshotJson.created_at * 1000))
    builder.build()
